import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Listbox } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  DocumentIcon,
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/react/solid";
import axios from "axios";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class WarehouseEditmodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      editid: this.props.WarehouseId,
      warehouse_name: "",
      warehouse_branch_id: 0,
      warehouse_attention: "",
      warehouse_street_one: "",
      warehouse_street_two: "",
      warehouse_city: "",
      warehouse_country_or_region_id: "",
      warehouse_state_id: "",
      warehouse_zip_code: "",
      warehouse_phone: "",
      warehouse_email: "",
      countriesList: [],
      stateList: [],
      branchesList: [],
      error_list: [],
      loader: "animate-pulse",
    };
    this.handleInput = this.handleInput.bind(this);
  }
  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    this.setLoaderFunction();

    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/countries", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ countriesList: res.data.countries });
      });

    const res1 = axios
      .get("public/api/branch", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({ branchesList: res1.data.branches });
      });

    const res2 = axios
      .get("public/api/warehouse/edit/" + this.state.editid, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({
          warehouse_name: res2.data.warehouse.warehouse_name,
          warehouse_branch_id: res2.data.warehouse.warehouse_branch_id,
          warehouse_attention: res2.data.warehouse.warehouse_attention,
          warehouse_street_one: res2.data.warehouse.warehouse_street_one,
          warehouse_street_two: res2.data.warehouse.warehouse_street_two,
          warehouse_city: res2.data.warehouse.warehouse_city,
          warehouse_country_or_region_id:
            res2.data.warehouse.warehouse_country_or_region_id,
          warehouse_state_id: res2.data.warehouse.warehouse_state_id,
          stateList: res2.data.warehouse.states,
          warehouse_zip_code: res2.data.warehouse.warehouse_zip_code,
          warehouse_phone: res2.data.warehouse.warehouse_phone,
          warehouse_email: res2.data.warehouse.warehouse_email,
        });
      });

    setTimeout(
      function () {
        //Start the timer
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    var token = localStorage.getItem("token");
    if (e.target.name === "warehouse_country_or_region_id") {
      this.setState({ loader: "animate-pulse" });
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          //console.log(res.data.states);
          this.setState({ loader: "" });
          this.setState({ stateList: res.data.states });
        });
    } else {
      // console.log("");
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputwarehouseFedit = (e) => {
    this.props.handleInputwarehouseAE(e);
  };

  saveItem = async (e) => {
    e.preventDefault();
this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/warehouse/update/" + this.state.editid,
      this.state,
      { headers }
    );

    if (res.data.success) {

      this.setState({ showmsg: true });
      this.handleInputwarehouseFedit(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      this.closeLoaderFuncion();
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
      this.closeLoaderFuncion();
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
  <div className={this.state.overLay} aria-hidden="true" />
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Update Warehouse
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                {" "}
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Name
                                </span>
                              </label>
                              <input
                                type="text"
                                name="warehouse_name"
                                id="warehouse_name"
                                onChange={this.handleInput}
                                value={this.state.warehouse_name}
                                autoComplete="warehouse_name"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_name-error"
                              >
                                {this.state.error_list.warehouse_name}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_branch_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Branch
                                </span>
                              </label>
                              <select
                                id="warehouse_branch_id"
                                name="warehouse_branch_id"
                                value={this.state.warehouse_branch_id}
                                onChange={this.handleInput}
                                autoComplete="warehouse_branch_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.branchesList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.warehouse_branch_id}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_attention"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Attention
                                </span>
                              </label>
                              <input
                                type="text"
                                name="warehouse_attention"
                                id="warehouse_attention"
                                value={this.state.warehouse_attention}
                                onChange={this.handleInput}
                                autoComplete=""
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.warehouse_attention}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_street_one"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Address Street1
                              </label>
                              <input
                                type="text"
                                name="warehouse_street_one"
                                id="warehouse_street_one"
                                value={this.state.warehouse_street_one}
                                onChange={this.handleInput}
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.warehouse_street_one}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_street_two"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Address Street2
                              </label>
                              <input
                                type="text"
                                name="warehouse_street_two"
                                id="Street_address2"
                                value={this.state.warehouse_street_two}
                                onChange={this.handleInput}
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_street_two-error"
                              >
                                {this.state.error_list.warehouse_street_two}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="warehouse_city"
                                className="block text-sm font-medium text-gray-700"
                              >
                                City
                              </label>
                              <input
                                type="text"
                                name="warehouse_city"
                                value={this.state.warehouse_city}
                                onChange={this.handleInput}
                                id="warehouse_city"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_city-error"
                              >
                                {this.state.error_list.warehouse_city}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="warehouse_country_or_region_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Country / Region*
                                </span>
                              </label>
                              <select
                                id="warehouse_country_or_region_id"
                                name="warehouse_country_or_region_id"
                                onChange={this.handleInput}
                                value={
                                  this.state.warehouse_country_or_region_id
                                }
                                autoComplete=""
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.countriesList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {
                                  this.state.error_list
                                    .warehouse_country_or_region_id
                                }
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="warehouse_state_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  State*
                                </span>
                              </label>
                              <select
                                id="warehouse_state_id"
                                name="warehouse_state_id"
                                onChange={this.handleInput}
                                value={this.state.warehouse_state_id}
                                autoComplete="warehouse_state_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.stateList.map((number) => (
                                  <option value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_state_id-error"
                              >
                                {this.state.error_list.warehouse_state_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="warehouse_zip_code"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Zip Code
                              </label>
                              <input
                                type="number"
                                name="warehouse_zip_code"
                                value={this.state.warehouse_zip_code}
                                onChange={this.handleInput}
                                id="warehouse_zip_code"
                                autoComplete="warehouse_zip_code"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_zip_code-error"
                              >
                                {this.state.error_list.warehouse_zip_code}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="warehouse_phone"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Phone
                              </label>
                              <input
                                type="number"
                                name="warehouse_phone"
                                id="warehouse_phone"
                                value={this.state.warehouse_phone}
                                onChange={this.handleInput}
                                autoComplete="address-level1"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_phone-error"
                              >
                                {this.state.error_list.warehouse_phone}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="warehouse_email"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Email
                              </label>
                              <input
                                type="text"
                                name="warehouse_email"
                                id="warehouse_email"
                                value={this.state.warehouse_email}
                                onChange={this.handleInput}
                                autoComplete="address-level1"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="warehouse_email-error"
                              >
                                {this.state.error_list.warehouse_email}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default WarehouseEditmodal;
